module.exports = __webpack_public_path__ + "static/red_dragon-50f7b6b8b1938298289eed90d29e7473.jpg";